import React from 'react';
import BasicInfo from './BasicInfo';
import Content from './Content';
import Modal from 'react-modal';
import validate from 'validate.js';
import {
  REGULAR_CONSTRAINST,
  MODULE_VALIDATION,
  QUESTION_CONSTRAINS,
  QUIZ_CONSTRAINS,
} from './constants';
import HttpClient from 'services/HttpClient';
import {inject} from 'mobx-react';
import _ from 'lodash';
import {observe} from 'mobx';
// import { convertToRaw } from 'draft-js';
// import draftToHtml from 'draftjs-to-html';
import {withRouter} from 'react-router-dom';
import { stateToHTML } from 'draft-js-export-html';

const CRETE_REGULAR = '/api/v1/workshops/';
const GET_WORKSHOP = '/api/v1/workshops/';
const FILES_KEYS = ['more_info', 'provider_logo'];
const DATES_KEYS = ['end_date', 'end_time', 'start_date', 'start_time'];


@withRouter
@inject('regularWorkshopCreate')
@inject('alert')
@inject('deleteModal')
@inject('user')
export default class Regular extends React.Component {

  state = {modalOpened: false};

  componentWillMount = () => {
    this.initialState(location);
    this.listener = this.props.history.listen( () => {
      this.initialState();
    });
  };

  deleteObject = () => {
    // new HttpClient().put(CRETE_REGULAR + this.props.regularWorkshopCreate.workshop.id, {more_info: null}).then( data => {
    //   this.setState({modalOpened: false});
    //   this.props.deleteModal.eventDelete({type: null});
    //   this.props.alert.success('Successfully deleted ');
    //   this.props.regularWorkshopCreate.handleChange({more_info: null});
    // }).catch( () => {
    //   this.props.alert.success('Something went wrong');
    // })
    if (this.props.deleteModal.deleteObject.type === "module")
      new HttpClient()
        .delete(`${DELETE_MODULE}${this.props.deleteModal.deleteObject.id}`)
        .then(data => {
          this.setState({ modalOpened: false });
          this.props.regularWorkshopCreate.deleteModule(
            this.props.deleteModal.deleteObject.index
          );
          this.props.deleteModal.eventDelete({ type: null });
          this.props.alert.success("Successfully deleted ");
        })
        .catch(data => this.props.alert.error("Something went wrong"));
    if (this.props.deleteModal.deleteObject.type === "question")
      new HttpClient()
        .delete(`${DELETE_QUESTION}${this.props.deleteModal.deleteObject.id}`)
        .then(() => {
          this.setState({ modalOpened: false });
          this.props.regularWorkshopCreate.deleteQuestion(
            this.props.deleteModal.deleteObject.moduleId,
            this.props.deleteModal.deleteObject.index
          );
          this.props.alert.success("Successfully deleted ");
        })
        .catch(() => this.props.alert.error("Something went wrong"));

    if (this.props.deleteModal.deleteObject.type === "file") {
      this.handleDeleteFile();
    }
  };

  handleDeleteFile = () => {
    switch (this.props.deleteModal.deleteObject.fileTo) {
      case "workshop":
        this.removeMoreInfo();
        break;
      case "module":
        this.removeModuleFile();
        break;
      case "question":
        this.removeQuestionFile();
    }
  };

  removeQuestionFile = () => {
    let deleteObject = this.props.deleteModal.deleteObject;
    let module = this.props.regularWorkshopCreate.modules[deleteObject.modal];
    let question = module.questions_attributes[deleteObject.question];
    let fileID = deleteObject.fileId;
    new HttpClient()
      .put(CRETE_REGULAR + this.props.regularWorkshopCreate.workshop.id, {
        id: this.props.regularWorkshopCreate.workshop.id,
        modules_attributes: [
          {
            id: module.id,
            questions_attributes: [
              {
                id: question.id,
                attachments_attributes: [{ id: fileID, _destroy: true }]
              }
            ]
          }
        ]
      })
      .then(() => {
        this.setState({ modalOpened: false });
        this.props.deleteModal.eventDelete({ type: null });
        this.props.alert.success("Successfully deleted ");
        this.props.regularWorkshopCreate.deleteQuestionFile(
          deleteObject.modal,
          deleteObject.question,
          deleteObject.file
        );
      })
      .catch(() => this.props.alert.error("Something went wrong"));
  };

  removeModuleFile = () => {
    let deleteObject = this.props.deleteModal.deleteObject;
    let moduleId = this.props.regularWorkshopCreate.modules[deleteObject.module].id;
    let fileID = deleteObject.fileId;
    new HttpClient()
      .put(CRETE_REGULAR + this.props.regularWorkshopCreate.workshop.id, {
        modules_attributes: [
          {
            id: moduleId,
            attachments_attributes: [{ id: fileID, _destroy: true }]
          }
        ]
      })
      .then(data => {
        this.setState({ modalOpened: false });
        this.props.alert.success("Successfully deleted");
        this.props.regularWorkshopCreate.deleteModuleFile(
          deleteObject.module,
          deleteObject.fileIndex
        );
      })
      .catch(() => this.props.alert.error("Something went wrong"));
  };

  removeMoreInfo = () => {
    new HttpClient()
      .put(CRETE_REGULAR + this.props.regularWorkshopCreate.workshop.id, {
        more_info: null
      })
      .then(data => {
        this.setState({ modalOpened: false });
        this.props.deleteModal.eventDelete({ type: null });
        this.props.alert.success("Successfully deleted ");
        this.props.regularWorkshopCreate.deleteFile();
      })
      .catch(() => {
        this.props.alert.success("Something went wrong");
      });
  };

  initialState = () => {
    let id = this.props.match.params.id;
    if(this.props.match.params.id){
      new HttpClient().get(GET_WORKSHOP + id).then(data => {
        this.props.regularWorkshopCreate.updateWorkshop(data.body.data.workshop)
        this.props.regularWorkshopCreate.setModules(data.body.data.workshop.modules);
      })
    }
  };

  decline = () => {
    this.setState({modalOpened: false});
  };

  submitRequest = () => {
    let form = new FormData();
    this.props.regularWorkshopCreate.clearErrors();
    const userId = this.props.user.getUser().id;
    const filteredModules = this.props.regularWorkshopCreate.modules ? this.props.regularWorkshopCreate.modules.filter(module => module.details) : [];
    let data = _.assign({}, this.props.regularWorkshopCreate.getWorkShop(), {
      modules_attributes: filteredModules,
    });
    const options = {
      entityStyleFn: ( entity ) => {
        if ( entity.get('type').toLowerCase() === 'link' ) {
          const data = entity.getData();

          return {
            element: 'a',
            attributes: {
              href: data.url,
              target: data.targetOption || data.target
            }
          };
        }
      }
    };
    console.log('this.props.regularWorkshopCreate.workshop ', this.props.regularWorkshopCreate.workshop );

    console.log('data from regular workshops', data);

    if (!data.deleteThisIds) {
      form.append("deleted_question_ids", null);
    }

    if (data.deleteThisIds) {
      data.deleteThisIds.forEach(id => {
        form.append("deleted_question_ids[]", id);
      });
    }
    data = _.mapValues(data, value => (value === "" ? null : value));
    if(data.more_info === 1)
      data.more_info = null;
    if(data.fee){
      let custom = validate({cost: data.cost},{cost: {presence: true, numericality: true}} );
      this.props.regularWorkshopCreate.addErrors(custom);
    }


    if(data.cpd_hours){
      let custom = validate({how_many_hours: data.how_many_hours},{how_many_hours: {presence: true, numericality: true}} );
      this.props.regularWorkshopCreate.addErrors(custom);
    }

    if(data.description) {
      // let description = stateToHTML(data.description.getCurrentContent(), options);
      // description = description.replace('<figure>', '').replace('</figure>', '')
      // _.assign(data, {description: description });

      if(data.description.trim() === '<p></p>')
        data.description = null;
    }
    else data.description = null;
    let errors = validate(data,REGULAR_CONSTRAINST);

    console.log('data editor after convert ', data);

    let newCaption;
    if(data.description) {
      newCaption = document.createElement('div');
      newCaption.innerHTML = data.description.replace(/<\/p>/gm, ' ').replace(/<(?:.|\n)*?>/gm, '');
      newCaption = newCaption.textContent;
    }

    let descriptionErrors = validate.single(newCaption ? newCaption.replace(/\s/g,'') : null,{
      presence: {message: 'Description is required'},
      length: {
        maximum: 5000,
        tooLong: 'Only 5,000 characters are allowed for the Description field'
      }
    },{fullMessages: false});
    if(descriptionErrors)
      errors = _.assign(errors, {description: descriptionErrors});

    if(data.target_audience.slice().length === 0){
      errors = _.assign({}, errors, {target_audience: 'Suitable for is required'})
    }
    this.props.regularWorkshopCreate.addErrors(errors);
    let documents = this.props.regularWorkshopCreate.documents;
    form.append('provider_bio','');

    _.mapKeys(data, (value, key) => {
      if(DATES_KEYS.includes(key)){
        if(value)
          form.append(key,value.format());
      }
      else if(key === 'description') {
        let formKey = 'description[]documents[]';
        form.append('description[]description', value);
        documents.forEach( el => {
          if(value.includes(el.src)) {
            form.append(formKey + 'src', el.src);
            form.append(formKey + 'file', el.file);
          }
        });
      }

      else if(FILES_KEYS.includes(key)) {
        if (value)
          form.append(key, value);
      }

      else if(key === 'target_audience'){
        value.forEach(target => {
          form.append('target_audience[]', target.value)
        })
      }


      else
        if(!!value && key !== 'modules_attributes')
          form.append(key,value);

    });
    if(!data.fee) {
      _.assign(data, {cost: 0});
      form.append('fee', false);
      form.append('cost', 0);
    }
    if(!data.cpd_hours){
      form.append('cpd_hours', false);
      form.append('how_many_hours', 0);
    }

    if (data.modules_attributes)
      data.modules_attributes.forEach((el, index) => {
        let questionIndex = index;
        el = _.assign({}, el);
        if (el.details && el.details !== "") {

          if (el.details.trim() === "<p></p>") el.details = null;
        }
        let moduleValidationObject = _.assign({}, el);
        if (moduleValidationObject.details) {
          let description = moduleValidationObject.details
            .trim()
            .replace(/\s/g, "");
          if (description !== "") {
            newCaption = document.createElement("div");
            newCaption.innerHTML = description;
            newCaption = newCaption.textContent;
            moduleValidationObject.details = newCaption.replace(/\s/g, "");
          }
        }
        let moduleErrors = validate(moduleValidationObject, MODULE_VALIDATION, {
          fullMessages: false
        });

        _.mapValues(moduleErrors, v => {
          let res = "";
          for (let i = 0; i < v.length; i++) res += `${v[i]}`;
          this.props.alert.error(res);
        });

        if (moduleErrors) hasErrors = true;
        this.props.regularWorkshopCreate.addModuleError(moduleErrors);
        let prefix = "modules_attributes";
        _.mapKeys(el, (value, key) => {
          if (key === "attachments_attributes") {
            let attachmentPrefix = "modules_attributes[]attachments_attributes";
            el.attachments_attributes.forEach(element => {
              _.mapKeys(element, (value, key) => {
                if (!!value && element.id === undefined) {
                  form.append(attachmentPrefix + "[]" + key, value);
                }
              });
            }); 
          }

          if (key === "questions_attributes") {
            if (el.module_type === "quiz" && !value.length) { 
              hasErrors = true;
              this.props.alert.error("Module with quiz can't be empty.");
            }

            let questionPrefix = "modules_attributes[]questions_attributes";
            el.questions_attributes.forEach((question, index) => {
              question = _.assign({}, question);

              let moduleErrors;
              if (el.module_type === "quiz") {
                moduleErrors = validate(question, QUIZ_CONSTRAINS, {
                  fullMessages: false
                });
              } else {
                moduleErrors = validate(question, QUESTION_CONSTRAINS, {
                  fullMessages: false
                });
              }

              _.mapValues(moduleErrors, v => {
                let res = "";
                for (let i = 0; i < v.length; i++) res += `${v[i]}`;
                if (el.module_type === "quiz") {
                  const title = el.title || (questionIndex + 1);
                  this.props.alert.error(
                    res +
                      title +
                      " (question " +
                      (index + 1) +
                      ")"
                  );
                } else {
                  this.props.alert.error(res);
                }
              });
              if (moduleErrors) {
                hasErrors = true;
                this.props.regularWorkshopCreate.addQuestionError(
                  questionIndex,
                  moduleErrors
                );
              } else {
                this.props.regularWorkshopCreate.removeQuestionError(
                  questionIndex,
                  index
                );
              }
              form.append(questionPrefix + "[]separator", "someseparator");
              _.mapKeys(question, (value, key) => {
                if (key === "attachments_attributes") {
                  let questionAttachmentPrefix =
                    "modules_attributes[]questions_attributes[]attachments_attributes";
                  value.forEach((el, index) => {
                    let attachments = el;
                    _.mapKeys(el, (value, key) => {
                      if (attachments.id === undefined)
                      form.append(
                          questionAttachmentPrefix + "[]" + key,
                          value
                        );
                    });
                  });
                } else if ((this.props.regularWorkshopCreate.workshop.id && key === 'correct') || !!value) {
                  if (key === "text") {
                    value = _.assign({}, { text: value, documents: [] });
                    form.append(
                      questionPrefix + "[]text[]text",
                      value.text
                    );
                    if (
                      this.props.regularWorkshopCreate.questionsMap.has(
                        `${questionIndex}${index}`
                      )
                    ) {
                      this.props.regularWorkshopCreate.questionsMap
                        .get(`${questionIndex}${index}`)
                        .files.forEach(el => {
                          if (value.text.includes(el.src)) {
                            form.append(
                              questionPrefix + "[]" + "text[]documents[]src",
                              el.src
                            );
                            form.append(
                              questionPrefix + "[]" + "text[]documents[]file",
                              el.file
                            );
                          }
                        });
                    }
                  } else form.append(questionPrefix + "[]" + key, value);
                }
              });
            });
          }
          if (value instanceof Array) return;

          if (!!value) {
            if (key === "details") {
              if (
                this.props.regularWorkshopCreate.modulesDetailsMap.has(questionIndex)
              ) {
                form.append(prefix + "[]" + "details[]details", value);
                let files = this.props.regularWorkshopCreate.modulesDetailsMap.get(
                  questionIndex
                ).files;
                value = _.assign({}, { details: value }, { documents: files });
                files.forEach(el => {
                  if (value.details.includes(el.src)) {
                    form.append(
                      prefix + "[]" + "details[]documents[]src",
                      el.src
                    );
                    form.append(
                      prefix + "[]" + "details[]documents[]file",
                      el.file
                    );
                  }
                });
              } else {
                console.warn("VALUE", value);
                form.append(prefix + "[]" + "details[]details", value);
              }
            } else {
              form.append(prefix + "[]" + key, value);
            }
          } else if(key === 'is_hidden' && !value) {
            form.append(prefix + "[]" + key, value);
          }
        });
      });


    console.log('form after perform data', form);


    if(!errors)
      if(data.id)
        new HttpClient().multipart(CRETE_REGULAR + data.id, form, 'PUT').then(data => {
          let role = this.props.user.getUser().role;
          if(role === 'coach' || role === 'admin')
            this.props.history.push('/provider/regular/' + data.body.data.workshop.id);
          else
            this.props.history.push('/regular_workshops');
            this.props.alert.success('Your workshop has been successfully updated.', 10000)
          }
        ).catch(err => console.log(err));

      else {
        form.append('provider_id', userId);

        new HttpClient().multipart(CRETE_REGULAR, form, 'POST').then(data => {
          let role = this.props.user.getUser().role;
          if(role === 'coach' || role === 'admin')
            this.props.history.push('/provider/regular/' + data.body.data.workshop.id);
          else
            this.props.history.push('/regular_workshops');
          this.props.alert.success('Thanks for submitting the Workshop info.' +
            ' It is currently being reviewed by the Therapy Academy team. If approved,' +
            ' we will let you know when the Workshop is published on Therapy Academy in due course.',10000)
          }
        ).catch(err => console.log(err));
      } else {
        _.mapValues(this.props.regularWorkshopCreate.errors, v => {
          let res = '';
          for(let i = 0; i < v.length; i++)
            res+=(`${v[i]}`)
          this.props.alert.error(res)

        });
    }
  };

  componentDidMount = () => {
    this.deleteObservable = observe(this.props.deleteModal, () => {
      if(this.props.deleteModal.deleteObject.type !== null){
        this.setState({modalOpened: true})
      }
    });

    this.props.regularWorkshopCreate.setInitialState();
  };

  componentWillUnmount = () => {
    this.listener();
    this.deleteObservable();
  };

  render(){
    return(
      <main className="main-content">
        <div className="container-fluid">
          <Modal
            isOpen={this.state.modalOpened}
            closeTimeoutMS={100}
            contentLabel="Modal"
          >
            <h1>Do you want delete it?</h1>
            <div className="modal-permissions-button">
              <div className="workshop-creator-sidebar-publish">
                <span className="btn prime bordered" onClick={this.deleteObject}>Accept</span></div>
              <div className="workshop-creator-sidebar-publish" style={{marginLeft: 15}}>
                <span className="btn prime bordered red" onClick={this.decline}>Decline</span></div>
            </div>
          </Modal>
          <div className="row regular-workshop workshop-creator create-regular">
            <BasicInfo submitRequest={this.submitRequest}/>
            <Content/>
          </div>
        </div>
      </main>

    )
  }
}



// WEBPACK FOOTER //
// ./src/components/create_regular_workshop/Regular.jsx